import { connect } from 'react-redux';
import { getTicketById, getLaundryRooms, updateTicketLaundryRoomById, resetPage, resetMeta } from '../../actions/TicketDetailPage';
import TicketDetailPage from './TicketDetailPage';


const mapsStateToProps = state => ({
	ticketDetailPageProps: state.ticketDetailPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getTicketById(id) {
		dispatch(getTicketById(id));
	},
	getLaundryRooms() {
		dispatch(getLaundryRooms());
	},
	updateTicketLaundryRoomById(options) {
		dispatch(updateTicketLaundryRoomById(options));
	},
	resetPage() {
		dispatch(resetPage());
	},
	resetMeta() {
		dispatch(resetMeta());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(TicketDetailPage);
